import React from 'react';
import RadioSelector from 'components/library/RadioSelector';
import MaterialUiField from '../MaterialUiField';

const RadioSelectorField = ({ value, ...props }) => (
  <MaterialUiField {...props} muiComponent={RadioSelector} useSetFieldValue useI18nPath />
);

export default RadioSelectorField;
